import 'containers/common/Detail.css';
import PropertySaleSheetList from "containers/property/PropertySaleSheetList";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";




export default class PropertySaleSheetModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
         
            isLoading: true            
        };
     
       
    }
    

    async componentDidMount() {
        
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        if (!this.props.show) {
            return null;
        }

           
    }

    


    renderComponent() {
        return (
            
            <Modal
                show={this.props.show}
                onHide={this.props.togglePropertySaleSheetModal}
                dialogClassName="modal-90w"
                >
                <Modal.Header closeButton>
                    <Modal.Title>Property Sale Sheets</Modal.Title>
                </Modal.Header>
                <Modal.Body>
           
              
                    Only the Cityscope Reference can be edited. The remaining fields are read only.
                    <PropertySaleSheetList
                        filter={this.props.filter}
                        isAuthenticated={this.props.isAuthenticated}
                        isLoading={this.state.isLoading}
                        controlType="table2"
                        saveForm={this.props.saveForm}
                        user={this.props.user}
                        data={this.props.data}
                        updateTableState={this.props.updateTableState}
                        saveRecord={this.props.saveRecord}
                        deleteRecord={this.props.deleteRecord}
                        salesheetid={this.props.salesheetid}
                        validateRelatedRecord={this.props.validateRelatedRecord}
                        />

                  
          
                    </Modal.Body>
            </Modal>
        );
    }
    
    


    render() {
        return (

            <div className="Edit">
                {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            </div>
        );
    }
}
